import React, { useState } from "react";
import { Row, Col, Card, Input } from "antd";
import { Link } from "react-router-dom";
import {
  BarChart2,
  FileText,
  Users,
  Activity,
  DollarSign,
  Folder,
  TrendingUp,
  PieChart,
  AlertTriangle,
  List,
  Archive,
  Shield,
  Gift,
} from "react-feather";

const { Search } = Input;

const categoryColors = {
  "Statutory Payroll Reports": "#007bff",
  "Management Payroll Reports": "#fd7e14",
};

const reportsData = [
  {
    category: "Statutory Payroll Reports",
    reports: [
      { icon: <DollarSign />, title: "TDS Reports", description: "Includes Form 24Q (quarterly TDS on salaries) and Form 16 (annual employee certificates). Details deductions and deposits.", link: "/reports/tds" },
      { icon: <Archive />, title: "EPF Returns", description: "Monthly ECR (Electronic Challan cum Return) for contributions (12% each from employer/employee).", link: "/reports/epf" },
      { icon: <Shield />, title: "ESI Returns", description: "Monthly contributions (0.75% employee, 3.25% employer); Form 5 for half-yearly returns.", link: "/reports/esi" },
      { icon: <FileText />, title: "Professional Tax Reports", description: "State-specific remittances (e.g., Rs 200-2,500/year in states like Maharashtra).", link: "/reports/professional-tax" },
      { icon: <Gift />, title: "Annual Bonus Reports", description: "Under Payment of Bonus Act; details 8.33%-20% bonus payouts.", link: "/reports/annual-bonus" },
    ],
  },
  {
    category: "Management Payroll Reports",
    reports: [
      { icon: <BarChart2 />, title: "Payroll Summary Reports", description: "Overview of total costs: gross/net pay, deductions, overtime (linked from attendance).", link: "/reports/payroll-summary" },
      { icon: <Users />, title: "Employee Detail Reports", description: "Per-employee breakdowns: earnings, deductions (e.g., PF/ESI from attendance-linked leaves), YTD summaries.", link: "/reports/employee-details" },
      { icon: <AlertTriangle />, title: "Tax Liability Reports", description: "Summarizes TDS, pending taxes, projections.", link: "/reports/tax-liability" },
      { icon: <TrendingUp />, title: "Payroll Variance Reports", description: "Compares current vs. previous payrolls, highlighting changes (e.g., due to attendance variations).", link: "/reports/payroll-variance" },
      { icon: <List />, title: "Deduction Registers", description: "Lists all deductions (e.g., loans, advances, attendance-based LOP).", link: "/reports/deduction-registers" },
      { icon: <FileText />, title: "Employee Salary Statements", description: "Individual total compensation overviews, including benefits.", link: "/reports/salary-statements" },
    ],
  },
];

const PayrollReportsLandingPage = () => {
  const [filteredReports, setFilteredReports] = useState(reportsData);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (value) => {
    setSearchQuery(value);
    if (!value) {
      setFilteredReports(reportsData);
    } else {
      const filtered = reportsData.map((category) => ({
        ...category,
        reports: category.reports.filter((report) =>
          report.title.toLowerCase().includes(value.toLowerCase())
        ),
      })).filter(category => category.reports.length > 0);
      setFilteredReports(filtered);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="page-header d-flex justify-content-between align-items-center">
          <div>
            <h3 className="page-title">Payroll Reports</h3>
            <p className="page-subtitle">Analyze payroll data, ensure compliance, and gain insights with our reports tailored for small organizations in India.</p>
          </div>
          <div className="filter-section">
            <Search placeholder="Search payroll reports..." allowClear enterButton onSearch={handleSearch} style={{ width: '300px' }} />
          </div>
        </div>
        {filteredReports.length > 0 ? (
          filteredReports.map((category, index) => (
            <div key={index} className="category-section">
              <h4 className="category-title">{category.category}</h4>
              <hr />
              <Row gutter={[16, 16]}>
                {category.reports.map((report, idx) => (
                  <Col key={idx} span={8}>
                    <Card hoverable className="report-card stylish-report-card" style={{ borderLeft: `4px solid ${categoryColors[category.category]}` }}>
                      <div className="icon-wrapper enhanced-icon" style={{ color: categoryColors[category.category] }}>{report.icon}</div>
                      <Link to={report.link} className="report-title-link stylish-title">
                        <h5 className="report-title">{report.title}</h5>
                      </Link>
                      <p className="report-description stylish-description">{report.description}</p>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ))
        ) : (
          <p>No reports found matching your criteria.</p>
        )}
      </div>
    </div>
  );
};

export default PayrollReportsLandingPage;